import React, { useState, useEffect } from "react";
import {
    MenuItem,
    Checkbox,
    FormControlLabel,
    withStyles,
} from "@material-ui/core";

const BlueCheckbox = withStyles({
    root: {
        color: "#005CC8",
        "&$checked": {
            color: "#005CC8",
        },
    },
    checked: {},
})(Checkbox);

const withMetadataIdsMultiselectCheckbox = (WrappedComponent) => (props) => {
    const [selectedValues, setSelectedValues] = useState(
        props.value || [],
    );
    const [anchorEl, setAnchorEl] = useState(null);

    useEffect(() => {
        const colId = props.column.colId;
        props.node.setDataValue(colId, selectedValues);
    }, [selectedValues, props.column.colId, props.node]);

    const toggleCheckbox = (opt) => {
        if (opt.id === "all") {
            setSelectedValues([]);
            return;
        }
        const isOptSelected = selectedValues?.some(
            (selected) => selected === opt._id,
        );
        const newValues = isOptSelected
            ? selectedValues.filter(
                (selected) => selected !== opt._id,
            )
            : [...selectedValues, opt._id]

        setSelectedValues(newValues);
    };

    const renderAllOption = () => (
        <MenuItem key={"all"} onClick={(e) => e.stopPropagation()}>
            <FormControlLabel
                control={
                    <BlueCheckbox
                        checked={!selectedValues?.length}
                        onChange={() => toggleCheckbox({ id: "all" })}
                    />
                }
                label={"All"}
            />
        </MenuItem>
    );

    const handleClose = () => {
        const colId = props?.column?.colId;
        const rowNode = props.api.getRowNode(props.node.id);
        if (rowNode) {
            const updatedData = {...rowNode.data, [colId]: selectedValues};
            rowNode.setData({...rowNode.data, [colId]: selectedValues});
        }
        props.api.stopEditing(true);
    };

    useEffect(() => {
        setAnchorEl(props.eGridCell);
    }, [props.eGridCell]);

    const isOptionChecked = (option) =>
        !selectedValues?.length ||
        selectedValues?.some(
            (selected) => selected === option._id,
        );

    const injectedProps = {
        toggleCheckbox,
        anchorEl,
        handleClose,
        renderAllOption,
        isOptionChecked,
    };

    return <WrappedComponent {...props} {...injectedProps} />;
};

export default withMetadataIdsMultiselectCheckbox;
